import styled, { css } from 'styled-components'
import type { TableHeadCellProps } from './types'

export const IconContainer = styled.div<Pick<TableHeadCellProps, 'direction'>>`
  margin-left: var(--space-200);

  display: flex;
  align-items: center;

  position: relative;
  top: -3px;

  opacity: ${({ direction }) => (direction ? '1' : '0')};
  transform: ${({ direction }) => (direction === 'asc' ? 'rotate(180deg)' : 'none')};
`

export const Container = styled.span<
  { $width: number } & Omit<TableHeadCellProps, 'width' | 'direction' | '$sortable'>
>`
  display: flex;
  align-items: center;
  justify-content: ${({ $alignment }) => ($alignment === 'right' ? 'flex-end' : 'flex-start')};
  flex: ${({ $width }) => $width};
  padding: var(--space-250) var(--space-200);
  min-width: ${({ $minWidth }) => ($minWidth ? `${$minWidth}px` : 'auto')};

  text-align: left;
  font-size: var(--font-size-300);
  letter-spacing: var(--font-letter-spacing-loose);
  color: var(--text-secondary);
  line-height: var(--font-line-height-300);

  user-select: none;

  ${({ $forOption }) =>
    $forOption &&
    css`
      flex: none;
      min-width: 0;
    `};

  ${({ onClick }) =>
    onClick &&
    css`
      cursor: pointer;

      &:hover > ${IconContainer} {
        opacity: 1;
      }
    `};
`
